import { Injectable } from '@angular/core';
import { ScreenSize } from '../models';

@Injectable({
  providedIn: 'root',
})
export class ScreenSizeService {
  get isXs() {
    return this.isLessThan(ScreenSize.sm);
  }

  isLessThan(screenSize: ScreenSize) {
    return window.innerWidth < screenSize;
  }

  isAtLeast(screenSize: ScreenSize) {
    return window.innerWidth >= screenSize;
  }
}
